var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.052 12.05l-7.749-1.065L17 3.647a1.094 1.094 0 00-1.998 0l-3.304 7.338-7.748 1.065a1.1 1.1 0 00-.625 1.869l5.714 5.704-1.432 8.083a1.097 1.097 0 001.624 1.146L16 24.96l6.77 3.892a1.097 1.097 0 001.624-1.146l-1.432-8.083 5.714-5.704a1.1 1.1 0 00-.624-1.87z",
    fill: "#FFBA00"
  }))));
}

export default SvgIconStarFull;